export const formatRadarValue = (value: number, isPercentage: boolean) => value * (isPercentage ? 100 : 1);
